import { Skeleton, styled, Typography } from '@mui/material';

import { ChkScreenReaderOnly } from '@ui/checkout-components';

import type { ContentProps } from './Content.types';

export function Content({
  dataTestId,
  isLoading,
  loadingAriaLabel,
  children,
  ...props
}: ContentProps) {
  if (isLoading) {
    return (
      <>
        <Skeleton width="75%" />
        <ChkScreenReaderOnly role="status">
          {loadingAriaLabel}
        </ChkScreenReaderOnly>
      </>
    );
  }

  return (
    <ContentLabel data-testid={dataTestId} {...props}>
      {children}
    </ContentLabel>
  );
}

const ContentLabel = styled(Typography)(({ theme }) => ({
  color: theme.tokens.cardValueHeader,
  ...theme.typography.body2,
  wordBreak: 'break-word',
  fontWeight: theme.typography.fontWeightMedium,
}));
